import history from './history';
import moment from 'moment';

export default class Auth {
  // removes user details from localStorage
  logout = () => {
    if (typeof window !== 'undefined') {
      // Clear access token and ID token from local storage
      localStorage.removeItem('access_token');
      localStorage.removeItem('id_token');
      localStorage.removeItem('user_id');
      localStorage.removeItem('expires_at');
      localStorage.removeItem('first_name');
      localStorage.removeItem('username');
      localStorage.removeItem('avatar_url');
      localStorage.removeItem('scopes');
      localStorage.removeItem('email');
      localStorage.removeItem('stream_token');
      localStorage.removeItem('name');
      localStorage.removeItem('categories');
      sessionStorage.removeItem('clipps_data');
      sessionStorage.removeItem('emailConfirmed');
      // navigate to the home route
      history.replace('/');
    }
  };

  // checks if the user is authenticated
  isAuthenticated = () => {
    if (typeof window !== 'undefined') {
      // Check whether the current time is past the
      // access token's expiry time
      let accessToken = localStorage.getItem('access_token'),
        expiresAt = localStorage.getItem('expires_at');

      return accessToken && moment().isBefore(expiresAt);
    }
  };

  getAccessToken() {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('access_token');
    }
  }

  getUserAvatar() {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('avatar_url') === 'null' ? null : localStorage.getItem('avatar_url');
    }
  }
}
